import { createStore } from 'satcheljs';
import ActivityFeedOptionState from './schema/ActivityFeedOptionState';

export default createStore<ActivityFeedOptionState>('activityFeedOption', {
    isInitialized: false,
    supportedTypes: null,
    disabledInFeedPanel: null,
});
